<template>
  <div class="item-container">
    <v-icon class="icon">
      {{ icon }}
    </v-icon>
    <h5 class="item-label">{{ label }}</h5>
  </div>
</template>

<script>
export default {
  name: "SideBarMenuItem",
  props: {
    icon: {
      type: String,
      default: 'mdi-check-circle'
    },
    label: {
      type: String,
      default: "Menu item"
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.item-container {
  display: flex;
  flex-direction: row;
  background-color: white;
  height: 3.5rem;
  align-items: center;
  padding-left: 1.75rem;
  cursor: pointer;
  /* justify-content: start; */
}

.item-container:hover {
  background-color: rgba(46, 91, 255, 0.15);
  border-left: thick solid #2e5bff;
}

.item-label {
  font-size: 1rem;
  color: #b0bac9;
  margin-left: 1rem;
  margin-bottom: 0;
}

.item-container:hover .item-label{
  color: #2e5bff;
}

.icon {
   color: #bfc5d2;
}
.item-container:hover .icon{
  color: #2e5bff;
  caret-color: #2e5bff;
}

</style>